// extracted by mini-css-extract-plugin
export default {"btn":"ButtonB_btn__oWiZJ"};